var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFastestdelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 12.6667C5.68696 12.6667 6.02609 12.5262 6.27614 12.2761C6.52619 12.0261 6.66667 11.687 6.66667 11.3333C6.66667 10.9797 6.52619 10.6406 6.27614 10.3905C6.02609 10.1405 5.68696 10 5.33333 10C4.97971 10 4.64057 10.1405 4.39052 10.3905C4.14048 10.6406 4 10.9797 4 11.3333C4 11.687 4.14048 12.0261 4.39052 12.2761C4.64057 12.5262 4.97971 12.6667 5.33333 12.6667ZM12 12.6667C12.3536 12.6667 12.6928 12.5262 12.9428 12.2761C13.1929 12.0261 13.3333 11.687 13.3333 11.3333C13.3333 10.9797 13.1929 10.6406 12.9428 10.3905C12.6928 10.1405 12.3536 10 12 10C11.6464 10 11.3072 10.1405 11.0572 10.3905C10.8071 10.6406 10.6667 10.9797 10.6667 11.3333C10.6667 11.687 10.8071 12.0261 11.0572 12.2761C11.3072 12.5262 11.6464 12.6667 12 12.6667Z",
    stroke: "#FE8710",
    strokeWidth: 0.8,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69984 11.3333H9.99984V4.4C9.99984 4.29391 9.9577 4.19217 9.88268 4.11716C9.80767 4.04214 9.70593 4 9.59984 4H0.666504M3.7665 11.3333H2.39984C2.34731 11.3333 2.29529 11.323 2.24676 11.3029C2.19823 11.2828 2.15414 11.2533 2.11699 11.2162C2.07985 11.179 2.05039 11.1349 2.03029 11.0864C2.01018 11.0379 1.99984 10.9859 1.99984 10.9333V7.66667",
    stroke: "#FE8710",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 6H3.99967",
    stroke: "#FE8710",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6H13.74C13.8173 6.00002 13.893 6.02245 13.9578 6.06457C14.0226 6.10669 14.0739 6.1667 14.1053 6.23733L15.2987 8.92267C15.3214 8.97365 15.3332 9.02884 15.3333 9.08467V10.9333C15.3333 10.9859 15.323 11.0379 15.3029 11.0864C15.2828 11.1349 15.2533 11.179 15.2162 11.2162C15.179 11.2533 15.1349 11.2828 15.0864 11.3029C15.0379 11.323 14.9859 11.3333 14.9333 11.3333H13.6667M10 11.3333H10.6667",
    stroke: "#FE8710",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastestdelivery);
export default __webpack_public_path__ + "static/media/Fastest delivery.4856d3ed6b218294c0cc00c2a471a0fb.svg";
export { ForwardRef as ReactComponent };